import {useInfiniteQuery} from "@tanstack/react-query";

import {ITEMS_PER_PAGE} from "@/src/modules/core/utils/constants";
import type {ParamsOptions} from "@/src/modules/core/types";

import {vehiclesService} from "../services";
import type {VehiclesListMeta} from "../types";

type UseInfiniteVehiclesOptions = {
  enabled?: boolean;
};

export function useInfiniteVehicles(
  options: ParamsOptions = {},
  queryOptions: UseInfiniteVehiclesOptions = {},
) {
  const {enabled = true, ...rest} = queryOptions;
  const {data, ...query} = useInfiniteQuery({
    queryKey: ["vehicles", "infinite", options],
    enabled,
    queryFn: ({pageParam = 0}) => {
      const page = {
        limit: ITEMS_PER_PAGE,
        offset: pageParam,
      };
      return vehiclesService.getVehicles({...options, page});
    },
    getNextPageParam: (lastPage, pages) => {
      const loadedItems = pages.reduce(
        (acc, page) => acc + page.data.length,
        0,
      );
      return loadedItems < lastPage.meta.total ? loadedItems : undefined;
    },
    initialPageParam: 0,
    ...rest,
  });

  const vehicles = data?.pages.flatMap((page) => page.data) ?? [];
  const listMeta = data?.pages[0]?.meta as VehiclesListMeta | undefined;
  const totalRecords = listMeta?.total ?? 0;

  return {
    vehicles,
    listMeta,
    totalRecords,
    ...query,
  };
}
